<template>
  <div
    :class="['speech_bubble', arrowDirectionClass]"
    :style="{ '--left': arrowPos }"
  >
    <p><slot></slot></p>
  </div>
</template>

<script>
export default {
  props: {
    arrowDirection: {
      type: String,
      default: 'bottom right',
    },
    arrowPos : {
      type: String,
      default: '50%',
    },
  },
  mounted() {
    document.addEventListener("click", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  },
  computed: {
    arrowDirectionClass() {
      const direction = this.arrowDirection.split(" ").join("_");
      return `arrow_direction-${direction}`;
    },
  },
  methods: {
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.speech_bubble {
  --left: 50%;

  position: relative;
  display: inline-block;
  padding: 0.5rem 1.5rem;
  min-width: 20%;
  color: $primary;
  font-weight: bold;
  background: #ffffff;
  text-align: center;

  z-index: var(--z-index-screen);

  border: calc(var(--size-base) * 4) solid $primary;
  border-radius: calc(var(--size-base) * 20);

  & > p {
    margin: 0;
    padding: 0;

    font-size: 1.2rem;
  }

  &::before {
    content: "";
    position: absolute;
    top: 66%;
    border-style: solid;
    border-width: 1rem 2rem 0 0;
    border-color: $primary transparent transparent;
    translate: -18% 100%;
    left: var(--left);
  }

  &::after {
    content: "";
    position: absolute;
    top: 55%;
    border-style: solid;
    border-width: 1rem 2rem 0 0;
    border-color: #ffffff transparent transparent;
    translate: -50% 100%;
    left: var(--left);
  }

  &.arrow_direction {
    &-top_right::before,
    &-top_right::after {
      transform: skew(-75deg);
      transform-origin: top;
    }

    &-top_left::before,
    &-top_left::after {
      transform: skew(50deg);
      transform-origin: top;
    }

    &-bottom_right::before,
    &-bottom_right::after {
      transform: skew(75deg);
      transform-origin: top;
    }

    &-bottom_left::before,
    &-bottom_left::after {
      transform: skew(-50deg);
      transform-origin: top;
    }
    &-bottom_left::before {
      translate: -76% 100%;
    }
  }
}
</style>